module.exports = __webpack_public_path__ + "img/testimonial_4.9fc94509.png";